import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Link } from 'react-router-dom';
import { createModal } from '@thermon-platforms/thermon-ui-core';
import useDevicesStore from 'store/devices';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import { ConfigureDeviceModal } from '../manage-devices';
import { getAllChildDevicesByType, getConfigItem, isDuo } from 'util/device';
import Actions from '../actions';


function BridgeTableRow({row}) {
  const [detail, setDetail] = useState();
  const [status, setStatus] = useState();
  const [, devicesStoreActions] = useDevicesStore();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const isDuoBridge = isDuo(row?.externalId);

  function editBridge(bridge) {
    const editBridgeModal = createModal(<ConfigureDeviceModal device={bridge} />);
    editBridgeModal.open()
      .then((res) => {
        // Handle side-effects
        devicesStoreActions.forceUpdate();
      })
      .catch(() => {/* no-op */})
  }

  useEffect(() => {
    devicesStoreActions.fetchStatus(row.id).then((status) => {
      setStatus(status);
    });

    devicesStoreActions.fetchDetail(row.id).then((detail) => {
      setDetail(detail);
    });
  }, [row]);

  return (
    <tr key={`device-${row.id}`}>
      <td>
        <span className={`status-icon signal ${status ? status.commStatus : ''}`}></span>
        <Link to={row.id}>{row.name}</Link>
      </td>
      {/* <td>95%</td> */}
      <td>
        {detail ? getConfigItem(detail, 'FirmwareVersion')?.value : ''}
      </td>
      <td>
        {detail && getConfigItem(detail, 'FirmwareDate')?.value ? new Date(getConfigItem(detail, 'FirmwareDate')?.value).toLocaleString() : ''}
      </td>
      <td>{getAllChildDevicesByType(row, 'Panel').length}</td>
      <td>
        {/*
          This should be using the type definition above but the deviceModel
          property for bridges is not working correctly. -jw 2025-05-20
        */}
        {usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles) ? <>
          <button
            className="settings"
            onClick={() => editBridge(detail)}
            data-tooltip-content={isDuoBridge ? t`Duo Settings` : t`Bridge Settings`}
            data-tooltip-id="control-tooltip"
          >
            <Trans>Settings</Trans>
          </button>
          <Actions device={row} />
        </> : <></>}
      </td>
    </tr>
  );
}

export default BridgeTableRow;
